module.exports = __webpack_public_path__ + "img/Winners-pana.697daeff.svg";